import React from 'react';
import { cn } from '@/utils/cn';
import styles from './Skeleton.module.css';

export interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  style?: React.CSSProperties;
}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant = 'rectangular', width, height, borderRadius, style: propStyle }, ref) => {
    const style: React.CSSProperties = {
      width: typeof width === 'number' ? `${width}px` : width,
      height: typeof height === 'number' ? `${height}px` : height,
      borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
      ...propStyle
    };

    return (
      <div
        ref={ref}
        className={cn(styles.skeleton, className)}
        data-variant={variant}
        style={style}
        aria-hidden="true"
      />
    );
  }
);

Skeleton.displayName = 'Skeleton';

export { Skeleton };
